export default function NoMatch () {
	return (
		<div className="mt-5 mb-5 text-center">
			<h1>404</h1>
			<h3 className="text-info">Not Found</h3>	
		</div>
	)
}